import { IToggle } from '@unleash/nextjs';
import { TFlagName } from '../types/UnleashContainer.types';

interface IBootstrap extends Omit<IToggle, 'name'> {
  name: TFlagName;
}

// Feature Flags default values. if unleash connection had issue and the features doesn't exist in storage
// Set only for flags that you want it to be enabled
export const bootstrap: IBootstrap[] = [
  {
    name: 'web.general.chatBot',
    enabled: true,
    impressionData: false,
    variant: {
      name: 'disabled',
      enabled: false,
    },
  },
  {
    name: 'web.card.cardtocard',
    enabled: true,
    impressionData: false,
    variant: {
      name: 'default',
      payload: {
        type: 'json',
        value:
          '{\n  "receiptTitle": [\n    {\n      "text": "اپلیکیشن مفید،",\n      "color": "#004C6A"\n    },\n    {\n      "text": "مسیر راحت سرمایه‌گذاری",\n      "color": "#00A796"\n    }\n  ],\n  "link": null\n}',
      },
      enabled: true,
    },
  },
];
